'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { RosterOutputPage } from '../-components/RosterOutputPage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/worker-roster/output/')({
  component: RosterOutputPage
});